'use client';
import { navbarOptions } from 'common-components/navbar/Navbar';
import { useRouter } from 'next/navigation';
import { UserPermission } from 'types/adminTypes';

let router: ReturnType<typeof useRouter> | null = null;

export const setRouter = (r: ReturnType<typeof useRouter>) => {
  router = r;
};

export const redirectToLogin = (path = '/sign-in') => {
  if (router) {
    router.replace(path);
    return;
  }

  if (typeof window !== 'undefined') {
    window.location.replace(path);
  }
};

export const getInitialRoute = (permissions: UserPermission[]) => {
  const route = navbarOptions.find((item) => item.key === permissions[0].module);
  if (route?.href) {
    return route?.href;
  } else if (route?.subItems && route?.subItems?.length > 0) {
    return route?.subItems[0].href;
  } else return '/unauthorised';
};
